import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../../services/service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(private router:Router, private service:ServiceService) {
    this.service.clearAll();
    this.router.navigate(['/']);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/logout/logout.component.ts